import { DateTime } from 'luxon';

export const REPORT_DATE_FORMAT = 'yyyy-MM-dd';

export const parseReportDate = (value, date) => {
  if (date instanceof Date && !Number.isNaN(date.getTime())) {
    return DateTime.fromJSDate(date).toFormat(REPORT_DATE_FORMAT);
  }
  if (typeof value === 'string' && value.trim()) {
    const parsed = DateTime.fromISO(value.trim());
    if (parsed.isValid) {
      return parsed.toFormat(REPORT_DATE_FORMAT);
    }
  }
  return null;
};
